import { useSession } from '@descope/react-sdk';
import { useAdminPortalConfig } from 'api/adminPortalConfig';
import { NoAccessReason } from 'types/access';
import { useLoggedInUser, useTenant } from './user';

export const useCanAccessAdminPortal = (): [boolean, NoAccessReason | null] => {
	const { data: adminPortalConfig } = useAdminPortalConfig();
	const { user, isUserLoading } = useLoggedInUser();
	const { tenant, needsSelection, isTenantless } = useTenant();
	const { isSessionLoading, claims } = useSession();

	if (!adminPortalConfig?.enabled) {
		return [false, NoAccessReason.APP_DISABLED];
	}
	if (isUserLoading || isSessionLoading) {
		return [false, NoAccessReason.LOADING];
	}
	// "claims" take a rendering cycle to populate. this check prevents a flicker on load.
	if (!user || !claims) {
		return [false, NoAccessReason.USER_NOT_LOGGED_IN];
	}
	if (needsSelection) {
		return [false, NoAccessReason.NEEDS_TENANT_SELECTION];
	}
	if (!tenant && !isTenantless) {
		return [false, NoAccessReason.TENANT_SELECTION_FAILED];
	}

	return [true, null];
};
